(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Bonnell-legal"] && !Shopify.designMode) return;
  try {
    
(function(){
  // Boot flag prevents double-init (Shopify theme editor re-renders)
  if (window.bonnellLegalBooted) return;
  window.bonnellLegalBooted = true;

  var ROOT_ID = 'bonnell-legal';

  function toggleAcc(trigger){
    try {
      if (!trigger) return;
      var body = trigger.nextElementSibling;
      if (!body) return;
      var willOpen = !body.classList.contains('bon-lg-open');
      var accordion = trigger.closest ? trigger.closest('.bon-lg-accordion') : null;
      if (accordion) {
        var openBodies = accordion.querySelectorAll('.bon-lg-acc-body.bon-lg-open');
        for (var i = 0; i < openBodies.length; i++) {
          openBodies[i].classList.remove('bon-lg-open');
          openBodies[i].style.maxHeight = '';
          var prev = openBodies[i].previousElementSibling;
          if (prev) prev.classList.remove('bon-lg-open');
        }
      }
      if (willOpen) {
        body.classList.add('bon-lg-open');
        trigger.classList.add('bon-lg-open');
        // scrollHeight — supports long content (Privacy Policy is > 2000px)
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    } catch (err) {
      if (window.console && console.warn) console.warn('[bonnell-legal] toggleAcc:', err);
    }
  }

  function onRootClick(e){
    var t = e.target;
    if (!t || !t.closest) return;
    var trigger = t.closest('.bon-lg-acc-trigger');
    if (trigger) toggleAcc(trigger);
  }

  function bonnellLegalInit(){
    try {
      var root = document.getElementById(ROOT_ID);
      if (!root) return;
      root.addEventListener('click', onRootClick, false);
    } catch (err) {
      if (window.console && console.warn) console.warn('[bonnell-legal] init:', err);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bonnellLegalInit);
  } else {
    bonnellLegalInit();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-page-805"] && !Shopify.designMode) return;
  try {
    
(function () {
  var TARGET = new Date(2026, 8, 1, 0, 0, 0).getTime(); // September 1, 2026 local midnight

  /* ----- flip-clock digits ----- */
  var root = document.getElementById("countdown");
  var digits = [];
  var CD_LABELS = ["Days","Hours","Minutes"];
  for (var grp = 0; grp < 3; grp++) {
    if (grp > 0) {
      var col = document.createElement("span");
      col.className = "cd-colon";
      col.textContent = ":";
      root.appendChild(col);
    }
    var unit = document.createElement("span");
    unit.className = "cd-unit";
    var gEl = document.createElement("span");
    gEl.className = "cd-group";
    for (var i = 0; i < 2; i++) {
      var cell = document.createElement("span");
      cell.className = "fd";
      var card = document.createElement("span");
      card.className = "fd-card";
      card.textContent = "0";
      cell.appendChild(card);
      gEl.appendChild(cell);
      digits.push({ card: card, value: null, timer: null });
    }
    var lab = document.createElement("span");
    lab.className = "cd-lab";
    lab.textContent = CD_LABELS[grp];
    unit.appendChild(gEl);
    unit.appendChild(lab);
    root.appendChild(unit);
  }

  function setDigit(d, n, fast) {
    if (d.value === n) return;
    if (d.value === null) { d.value = n; d.card.textContent = n; return; }
    var card = d.card, cell = card.parentNode;
    /* finalize any roll still in progress */
    clearTimeout(d.timer);
    if (d.nextEl) { d.nextEl.remove(); d.nextEl = null; }
    card.classList.remove("roll-out");
    card.textContent = d.value;
    d.value = n;
    var nx = document.createElement("span");
    nx.className = "fd-next";
    nx.textContent = n;
    cell.appendChild(nx);
    d.nextEl = nx;
    void nx.offsetHeight;
    card.classList.add("roll-out");
    nx.classList.add("roll-in");
    d.timer = setTimeout(function () {
      card.textContent = n;
      card.classList.remove("roll-out");
      nx.remove();
      if (d.nextEl === nx) d.nextEl = null;
    }, fast ? 95 : 215);
  }

  function fmtSeconds(s) {
    var days = Math.floor(s / 86400);
    var hrs  = Math.floor((s % 86400) / 3600);
    var mins = Math.floor((s % 3600) / 60);
    var secs = s % 60;
    return String(Math.min(days, 99)).padStart(2, "0") +
           String(hrs).padStart(2, "0") +
           String(mins).padStart(2, "0");
  }

  /* spin up from zero to the actual time with fast flips */
  var spinning = false, spinTimer = null;
  function spinUp() {
    clearInterval(spinTimer);
    spinning = true;
    root.classList.add("spin");
    var goal = Math.max(0, Math.floor((TARGET - Date.now()) / 1000));
    var t0 = performance.now(), dur = 1700;
    var z = fmtSeconds(0);
    for (var i = 0; i < 6; i++) setDigit(digits[i], +z[i], true);
    spinTimer = setInterval(function () {
      var p = Math.min(1, (performance.now() - t0) / dur);
      var e = 1 - Math.pow(1 - p, 3);
      var str = fmtSeconds(Math.round(goal * e));
      for (var i = 0; i < 6; i++) setDigit(digits[i], +str[i], true);
      if (p >= 1) {
        clearInterval(spinTimer);
        spinning = false;
        root.classList.remove("spin");
      }
    }, 75);
  }

  function tick() {
    if (spinning) return;
    var ms = Math.max(0, TARGET - Date.now());
    var str = fmtSeconds(Math.floor(ms / 1000));
    for (var i = 0; i < 6; i++) setDigit(digits[i], +str[i]);
  }

  spinUp();
  setInterval(tick, 250);

  /* ----- countdown glitch: brief, occasional ----- */
  var cdEl = document.getElementById("countdown");
  function doGlitch() {
    cdEl.classList.add("glitch");
    setTimeout(function () { cdEl.classList.remove("glitch"); }, 90);
    setTimeout(doGlitch, 4500 + Math.random() * 6000);
  }
  /* glitch disabled for the clean countdown look */

  /* ----- hero carousel: sliding track, manual + drag/scroll, video end advances once ----- */
  var vid = document.getElementById("heroVideo");
  var track = document.getElementById("heroTrack");
  var slides = document.querySelectorAll("#hero .hero-slide");
  var dots = document.querySelectorAll("#heroDots button");
  var cur = 0;

  var len = slides.length;

  /* clones on both ends for seamless wrap-around */
  var cloneFirst = slides[0].cloneNode(true);
  var cloneLast = slides[len - 1].cloneNode(true);
  [cloneFirst, cloneLast].forEach(function (c) {
    c.classList.remove("on");
    c.removeAttribute("id");
    c.querySelectorAll("[id]").forEach(function (el) { el.removeAttribute("id"); });
    var cv = c.querySelector("video");
    if (cv) { cv.removeAttribute("autoplay"); cv.muted = true; }
  });
  track.appendChild(cloneFirst);
  track.insertBefore(cloneLast, slides[0]);

  function setTransform(noAnim) {
    if (noAnim) {
      track.style.transition = "none";
      track.style.transform = "translateX(" + (-(cur + 1) * 100) + "%)";
      void track.offsetWidth;
      track.style.transition = "";
    } else {
      track.style.transform = "translateX(" + (-(cur + 1) * 100) + "%)";
    }
  }
  function apply() { setTransform(false); }

  var logical = 0;
  function goTo(i) {
    i = Math.max(-1, Math.min(len, i));
    var newLogical = ((i % len) + len) % len;
    if (newLogical !== logical) {
      slides[logical].classList.remove("on");
      dots[logical].classList.remove("on");
      slides[newLogical].classList.add("on");
      dots[newLogical].classList.add("on");
      logical = newLogical;
      if (logical === 0) { if (vid && vid.play) { vid.currentTime = 0; vid.play(); } spinUp(); }
      else if (vid && vid.pause) { vid.pause(); }
    }
    cur = i;
    apply();
  }
  /* after sliding onto a clone, jump silently to the real slide */
  track.addEventListener("transitionend", function (e) {
    if (e.target !== track) return;
    if (cur === len) { cur = 0; setTransform(true); }
    else if (cur === -1) { cur = len - 1; setTransform(true); }
  });
  setTransform(true);
  if (vid) vid.addEventListener("ended", function () {
    if (cur === 0) goTo(1);
  });
  document.getElementById("heroPrev").addEventListener("click", function () { goTo(cur - 1); });
  document.getElementById("heroNext").addEventListener("click", function () { goTo(cur + 1); });
  dots.forEach(function (d, i) { d.addEventListener("click", function () { goTo(i); }); });

  /* drag / swipe */
  var dragging = false, startX = 0, dx = 0;
  function dragBase() { return -(cur + 1) * 100; }
  track.addEventListener("pointerdown", function (e) {
    if (e.target.closest("a, button")) return;
    e.preventDefault();
    dragging = true; startX = e.clientX; dx = 0;
    track.classList.add("dragging");
    track.setPointerCapture(e.pointerId);
  });
  track.addEventListener("pointermove", function (e) {
    if (!dragging) return;
    dx = e.clientX - startX;
    track.style.transform = "translateX(calc(" + dragBase() + "% + " + dx + "px))";
  });
  function endDrag(e) {
    if (!dragging) return;
    dragging = false;
    track.classList.remove("dragging");
    var t = track.clientWidth * 0.12;
    if (dx < -t) goTo(cur + 1);
    else if (dx > t) goTo(cur - 1);
    else if (e && Math.abs(dx) < 8) {
      /* plain click: left half = previous, right half = next */
      var r = document.getElementById("hero").getBoundingClientRect();
      goTo(e.clientX < r.left + r.width / 2 ? cur - 1 : cur + 1);
    }
    else apply();
    dx = 0;
  }
  track.addEventListener("pointerup", endDrag);
  track.addEventListener("pointercancel", function () { dragging = false; track.classList.remove("dragging"); apply(); dx = 0; });

  /* horizontal trackpad scroll */
  var lastWheel = 0;
  document.getElementById("hero").addEventListener("wheel", function (e) {
    if (Math.abs(e.deltaX) <= Math.abs(e.deltaY) || Math.abs(e.deltaX) < 25) return;
    e.preventDefault();
    var now = Date.now();
    if (now - lastWheel < 800) return;
    lastWheel = now;
    goTo(cur + (e.deltaX > 0 ? 1 : -1));
  }, { passive: false });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
